import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../utils/formatDate";
import { Button, Popconfirm } from "antd";
import { startUpdateBotonesCambioRol } from "../../../../../context/actions/ptActions";

export const SolicitudModeloRefactura = () => {
  const dispatch = useDispatch();
  const {
    fechaSolicitudModeloRefactura,
    solicitudModeloRefactura,
    confirmacionSolicitudModeloRefactura,
    fechaConfirmacionSolicitudModeloRefactura,
  } = useSelector((state) => state.ptReducer.ptDetalle.servicioPT);

  const submit = (tipo) => dispatch(startUpdateBotonesCambioRol(tipo));

  //
  return (
    <div className="SmallCard">
      <div>Solicitud Modelo Refactura</div>

      {solicitudModeloRefactura ? (
        <div>{formatDate(fechaSolicitudModeloRefactura)}</div>
      ) : (
        <div>
          <Popconfirm
            onConfirm={() => submit("SolicitudModeloRefactura")}
            title="¿Está seguro de establecer estatus?"
          >
            <Button type="link">Establecer</Button>
          </Popconfirm>
        </div>
      )}
      <hr />

      {solicitudModeloRefactura && (
        <>
          <div>Confirmado</div>
          {confirmacionSolicitudModeloRefactura ? (
            <div>{formatDate(fechaConfirmacionSolicitudModeloRefactura)}</div>
          ) : (
            <div>
              <Popconfirm
                onConfirm={() => submit("ConfirmacionSolicitudModeloRefactura")}
                title="¿Está seguro de establecer estatus?"
              >
                <Button type="link">Confirmar</Button>
              </Popconfirm>
            </div>
          )}
        </>
      )}
    </div>
  );
};
